export const MOCK_CONTACT_DETAILS = {
  entity: {
    _org: 'test-org',
    _schema: 'contact',
    last_name: 'Spark',
    first_name: 'Max',
    email: [
      {
        email: 'maxspark360@gmail.com',
        _id: 'HfAOh-AdruvBugA1FbjQf',
        id: 'q37xcz3'
      }
    ],
    payment: [
      {
        _tags: [],
        _id: 'UvxxbZ13mCnwchDZxheL8',
        data: {
          consent: true,
          fullname: 'Max Spark',
          bic_number: 'INGDDEFFXXX',
          bank_name: 'ING-DiBa',
          iban: 'DE02500105170137075030',
          start_date: '2025-01-01'
        },
        type: 'payment_sepa',
        id: 'eb4tss8'
      }
    ],
    birthdate: '1982-09-01',
    address: [
      {
        country: 'DE',
        city: 'Köln',
        _tags: ['delivery', 'billing'],
        additional_info: 'Penthouse',
        street: 'Adolf-Fischer-Str.',
        street_number: '2',
        _id: 'L6sB14Iori1DB0PodxizK',
        postal_code: '50670',
        id: '4ci2bne'
      }
    ],
    phone: [
      {
        phone: '012341234123',
        _id: 'UAa6m3SewPKOWJJXTXC3G',
        id: 'ewodw6a'
      }
    ],
    _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
    _created_at: '2025-04-04T09:18:17.430Z',
    _title: 'Max Spark',
    consent_email_marketing: {
      status: 'active',
      identifiers: [
        {
          identifier: 'maxspark360@gmail.com',
          status: 'active'
        }
      ]
    },
    consent_sms_marketing: {
      status: 'active',
      identifiers: [
        {
          identifier: '012341234123',
          status: 'active'
        }
      ]
    },
    consent_phone_call: {
      status: 'active',
      identifiers: [
        {
          identifier: '012341234123',
          status: 'active'
        }
      ]
    },
    consent_print_marketing: {
      status: 'unknown',
      identifiers: [
        {
          identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          status: 'unknown'
        }
      ]
    },
    _files: {
      $relation: [
        {
          entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
        },
        {
          entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
        },
        {
          entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
        },
        {
          entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
        },
        {
          entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
        },
        {
          entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
        },
        {
          entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
        },
        {
          entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
        }
      ]
    },
    first_ecp_login: '2025-04-04T13:56:15.807Z',
    _pending_changes: {},
    journey_actions: [],
    files: [
      {
        filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
        access_control: 'public-read',
        document_type: 'document',
        _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
        _purpose: [
          'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
          'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
          '6cf77479-becb-408b-a72e-b342bdc87f09',
          '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
        ],
        shared_with_end_customer: true,
        type: 'document',
        public_url:
          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
        size_bytes: 156167,
        readable_size: '152.51 KB',
        mime_type: 'application/pdf',
        s3ref: {
          bucket: 'epilot-prod-user-content',
          key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
        },
        versions: [
          {
            filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
            access_control: 'public-read',
            document_type: 'document',
            _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
            _purpose: [
              'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
              'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
              '6cf77479-becb-408b-a72e-b342bdc87f09',
              '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
            ],
            shared_with_end_customer: true,
            type: 'document',
            public_url:
              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
            size_bytes: 156167,
            readable_size: '152.51 KB',
            mime_type: 'application/pdf',
            s3ref: {
              bucket: 'epilot-prod-user-content',
              key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
            }
          }
        ],
        _schema: 'file',
        _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
        _org: 'test-org',
        _created_at: '2025-04-07T07:16:36.872Z',
        _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
        _updated_at: '2025-04-07T07:16:38.668Z'
      },
      {
        filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
        access_control: 'public-read',
        document_type: 'document',
        _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
        _purpose: [
          'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
          'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
          '6cf77479-becb-408b-a72e-b342bdc87f09',
          '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
        ],
        shared_with_end_customer: true,
        type: 'document',
        public_url:
          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
        size_bytes: 153036,
        readable_size: '149.45 KB',
        mime_type: 'application/pdf',
        s3ref: {
          bucket: 'epilot-prod-user-content',
          key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
        },
        versions: [
          {
            filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
            access_control: 'public-read',
            document_type: 'document',
            _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
            _purpose: [
              'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
              'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
              '6cf77479-becb-408b-a72e-b342bdc87f09',
              '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
            ],
            shared_with_end_customer: true,
            type: 'document',
            public_url:
              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
            size_bytes: 153036,
            readable_size: '149.45 KB',
            mime_type: 'application/pdf',
            s3ref: {
              bucket: 'epilot-prod-user-content',
              key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
            }
          }
        ],
        _schema: 'file',
        _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
        _org: 'test-org',
        _created_at: '2025-04-07T07:00:37.276Z',
        _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
        _updated_at: '2025-04-07T07:00:38.801Z'
      },
      {
        filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
        access_control: 'public-read',
        document_type: 'document',
        _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
        _purpose: [
          'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
          'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
          '6cf77479-becb-408b-a72e-b342bdc87f09',
          '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
        ],
        shared_with_end_customer: true,
        type: 'document',
        public_url:
          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
        size_bytes: 156303,
        readable_size: '152.64 KB',
        mime_type: 'application/pdf',
        s3ref: {
          bucket: 'epilot-prod-user-content',
          key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
        },
        versions: [
          {
            filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
            access_control: 'public-read',
            document_type: 'document',
            _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
            _purpose: [
              'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
              'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
              '6cf77479-becb-408b-a72e-b342bdc87f09',
              '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
            ],
            shared_with_end_customer: true,
            type: 'document',
            public_url:
              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
            size_bytes: 156303,
            readable_size: '152.64 KB',
            mime_type: 'application/pdf',
            s3ref: {
              bucket: 'epilot-prod-user-content',
              key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
            }
          }
        ],
        _schema: 'file',
        _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
        _org: 'test-org',
        _created_at: '2025-04-04T13:52:22.441Z',
        _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
        _updated_at: '2025-04-04T13:52:24.321Z'
      }
    ],
    language: 'en',
    customer_number: '1234567880',
    salutation: 'Mr.',
    inbetriebnahme: false,
    _updated_at: '2025-06-12T06:03:13.192Z'
  },
  files: [
    {
      filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
      access_control: 'public-read',
      document_type: 'document',
      _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
      _purpose: [
        'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
        'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
        '6cf77479-becb-408b-a72e-b342bdc87f09',
        '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
      ],
      shared_with_end_customer: true,
      type: 'document',
      public_url:
        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
      size_bytes: 156167,
      readable_size: '152.51 KB',
      mime_type: 'application/pdf',
      s3ref: {
        bucket: 'epilot-prod-user-content',
        key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
      },
      versions: [
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156167,
          readable_size: '152.51 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          }
        }
      ],
      _schema: 'file',
      _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
      _org: 'test-org',
      _created_at: '2025-04-07T07:16:36.872Z',
      _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
      _updated_at: '2025-04-07T07:16:38.668Z'
    },
    {
      filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
      access_control: 'public-read',
      document_type: 'document',
      _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
      _purpose: [
        'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
        'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
        '6cf77479-becb-408b-a72e-b342bdc87f09',
        '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
      ],
      shared_with_end_customer: true,
      type: 'document',
      public_url:
        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
      size_bytes: 153036,
      readable_size: '149.45 KB',
      mime_type: 'application/pdf',
      s3ref: {
        bucket: 'epilot-prod-user-content',
        key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
      },
      versions: [
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 153036,
          readable_size: '149.45 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          }
        }
      ],
      _schema: 'file',
      _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
      _org: 'test-org',
      _created_at: '2025-04-07T07:00:37.276Z',
      _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
      _updated_at: '2025-04-07T07:00:38.801Z'
    },
    {
      filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
      access_control: 'public-read',
      document_type: 'document',
      _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
      _purpose: [
        'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
        'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
        '6cf77479-becb-408b-a72e-b342bdc87f09',
        '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
      ],
      shared_with_end_customer: true,
      type: 'document',
      public_url:
        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
      size_bytes: 156303,
      readable_size: '152.64 KB',
      mime_type: 'application/pdf',
      s3ref: {
        bucket: 'epilot-prod-user-content',
        key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
      },
      versions: [
        {
          filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156303,
          readable_size: '152.64 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          }
        }
      ],
      _schema: 'file',
      _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
      _org: 'test-org',
      _created_at: '2025-04-04T13:52:22.441Z',
      _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
      _updated_at: '2025-04-04T13:52:24.321Z'
    }
  ],
  relations: [],
  journey_actions: []
}
